/**
 * Default Theme Configuration
 *
 * NOTE: All color/theme CSS variables are defined in colors.scss
 * This file only contains non-CSS resources like logo components.
 */

// Default camera aperture logo (MIT License)
import { ReactComponent as ApertureSVG } from '@assets/icons/aperture.svg';

const defaultTheme = {
    // Logo component (React SVG)
    logoComponent: ApertureSVG,
};

export default defaultTheme;
